import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AppShell } from "../components/layout/AppShell";
import { myRequests } from "../api/hr";
import { balance as timeOffBalance, listMine as timeOffMine } from "../api/timeOff";
import { LeavesTabContent } from "../features/hr/LeavesTabContent";
import { RequestStatusList } from "../features/hr/RequestStatusList";

export default function MyRequestsPage() {
  const { t } = useTranslation();
  const [leaves, setLeaves] = useState([]);
  const [timeOff, setTimeOff] = useState(null);
  const [timeOffList, setTimeOffList] = useState([]);
  const [reload, setReload] = useState(0);

  const load = async () => {
    const d = await myRequests();
    setLeaves(d.leaves || []);
    try { setTimeOff(await timeOffBalance()); } catch { /* time-off feature not enabled */ }
    try { setTimeOffList(await timeOffMine()); } catch { /* time-off feature not enabled */ }
  };
  useEffect(() => { load(); }, [reload]);
  const bump = () => setReload((r) => r + 1);

  return (
    <AppShell title={t("myRequests.leavesTitle")} subtitle={t("myRequests.leavesSubtitle")}>
      <div className="grid gap-6" data-testid="my-requests-page">
        <LeavesTabContent timeOff={timeOff} onDone={bump} reloadToken={reload} />
        <RequestStatusList data={{ leaves, timeOff: timeOffList }} reload={load} />
      </div>
    </AppShell>
  );
}
